import { useState } from "react";
import { LuCheck, LuCopy } from "react-icons/lu";
import { copyTextToClipboard } from "@/utils/copyToClipboard";
import styles from "./CopyCouponButton.module.css";

export default function CopyCouponButton({
  code,
  className = "",
  iconSize = 13,
  copiedLabel = "Copied!",
}) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const ok = await copyTextToClipboard(code);
    if (!ok) return;

    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
  };

  return (
    <span className={styles.root}>
      {copied ? (
        <span className={styles.copiedToast} role="status" aria-live="polite">
          {copiedLabel}
        </span>
      ) : null}
      <button
        type="button"
        className={`${styles.copyBtn} ${copied ? styles.copyBtnCopied : ""} ${className}`}
        aria-label={copied ? "Copied" : "Copy coupon code"}
        onClick={handleCopy}
      >
        {copied ? <LuCheck size={iconSize} /> : <LuCopy size={iconSize} />}
      </button>
    </span>
  );
}
